import React, { useMemo } from 'react';
import { Tree } from 'antd';
import type { DataNode } from 'antd/es/tree';

interface HierarchicalTreeProps<T> {
  data: T[];
  buildTree: (data: T[]) => DataNode[];
  loading?: boolean;
}

const HierarchicalTree = <T,>({
  data,
  buildTree,
}: HierarchicalTreeProps<T>) => {
  const treeData = useMemo(() => buildTree(data), [data, buildTree]);

  return <Tree treeData={treeData} defaultExpandAll showLine />;
};

export default HierarchicalTree;
